<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col lg:flex-row gap">
    <h2 class="col-span-2 shrink-0">Zahlen,<br />die für uns sprechen.</h2>

    <div class="grid grid-cols-2 md:!flex gap flex-wrap justify-between w-full text-dark">
        <div class="flex flex-col font-lighter items-center md:items-end">
            <span class="text-6xl"><span class="text-secondary-600">></span>50</span>
            <span class="leading-none text-right">betreute<br />Kunden</span>
        </div>

        <div class="flex flex-col font-lighter items-center md:items-end">
            <span class="text-6xl"><span class="text-secondary-600">></span>70</span>
            <span class="leading-none text-right">umgesetzte<br />Projekte</span>
        </div>

        <div class="flex flex-col font-lighter items-center md:items-end">
            <span class="text-6xl"><span class="text-secondary-600"></span>14</span>
            <span class="leading-none text-right">Jahre<br />Erfahrung</span>
        </div>

        <div class="flex flex-col font-lighter items-center md:items-end">
            <span class="text-6xl">+30<span class="text-secondary-600">%</span></span>
            <span class="leading-none text-right">Steigerung der<br />Conversion Rate</span>
        </div>
    </div>
</div>
